import { render } from "./Info5.vue?vue&type=template&id=17def844&scoped=true"
import script from "./Info5.vue?vue&type=script&lang=js"
export * from "./Info5.vue?vue&type=script&lang=js"

import "./Info5.vue?vue&type=style&index=0&id=17def844&scoped=true&lang=css"

import exportComponent from "C:\\Users\\fchristo.ETAGEN\\Documents\\Adam-Backend\\adam-aibackend\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17def844"]])

export default __exports__